import { render, staticRenderFns } from "./WrongCartType.vue?vue&type=template&id=314cb546&"
import script from "./WrongCartType.vue?vue&type=script&lang=js&"
export * from "./WrongCartType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports